// $(document).ready(function() {
//     $(window).scroll(function() {
//         var scrollPosition = $(window).scrollTop();
//
//         if (scrollPosition > 10) {
//             $(".header").addClass("scrolled");
//         } else {
//             $(".header").removeClass("scrolled");
//         }
//     });
// });

document.addEventListener("DOMContentLoaded", function() {
    var header = document.querySelector(".header");

    window.addEventListener("scroll", function() {
        var scrollPosition = window.scrollY || document.documentElement.scrollTop;

        if (scrollPosition > 10) {
            header.classList.add("scrolled");
        } else {
            header.classList.remove("scrolled");
        }
    });
});


// const scrollTracker = document.querySelector('.scroll-tracker');
//
// const scrollTrackingTimeline = new ScrollTimeline({
//     source: document.scrollingElement,
//     orientation: "block",
//     scrollOffsets: [CSS.percent(0), CSS.percent(100)]
// });
//
// scrollTracker.animate(
//     {
//         transform: ['scaleX(0)', 'scaleX(1)']
//     },
//     {
//         duration: 1,
//         timeline: scrollTrackingTimeline
//     }
// );
//
//
//
//
// // const animatedImages = document.querySelectorAll('.image-rotate-in');
// //
// // animatedImages.forEach(image => {
// //     const animatedImageTimeline = new ScrollTimeline({
// //         scrollOffsets: [
// //             { target: image, edge: "end", threshold: "0" },
// //             { target: image, edge: "start", threshold: "1" }
// //         ]
// //     });
// //
// //     image.animate(
// //         {
// //             transform: [
// //                 "prespective(1000px) rotateX(45deg)",
// //                 "prespective(1000px) rotateX(0)"
// //             ],
// //             // opacity: [ "0", "1" ]
// //         },
// //         {
// //             duration: 1,
// //             timeline: animatedImageTimeline
// //         }
// //     )
// //
// // });
//
//
//
// const animatedImage = document.querySelector('.image-rotate-in');
//
// const imageOffsetTop = animatedImage.offsetTop;
// const imageHeight = animatedImage.offsetHeight;
//
// console.log(imageOffsetTop);
// console.log(imageHeight);
//
// const animatedImageTimeline = new ScrollTimeline({
//     // scrollOffsets: [
//     //     { target: animatedImage, edge: "end", threshold: "0" },
//     //     { target: animatedImage, edge: "start", threshold: "1" }
//     // ]
//     scrollOffsets: [
//         CSS.px(imageOffsetTop + imageHeight - window.innerHeight),
//         CSS.px(imageOffsetTop - 10)
//     ]
// });
//
// animatedImage.animate(
//     {
//         transform: ["translateY(100px)", "translateY(0)"],
//         opacity: [ "0", "1" ]
//     },
//     {
//         duration: 1,
//         easing: "linear",
//         timeline: animatedImageTimeline
//     }
// )


AOS.init();





// var winScrollTop=0;
//
// $.fn.is_on_screen = function(){
//     var win = $(window);
//     var viewport = {
//         top : win.scrollTop(),
//         left : win.scrollLeft()
//     };
//     //viewport.right = viewport.left + win.width();
//     viewport.bottom = viewport.top + win.height();
//
//     var bounds = this.offset();
//     //bounds.right = bounds.left + this.outerWidth();
//     bounds.bottom = bounds.top + this.outerHeight();
//
//     return (!(viewport.bottom < bounds.top || viewport.top > bounds.bottom));
// };
//
// function parallax() {
//     var scrolled = $(window).scrollTop();
//     $('.parallax-wrapper').each(function(){
//
//         if ($(this).is_on_screen()) {
//             var firstTop = $(this).offset().top;
//             var $parallaxEl = $(this).find(".parallax");
//             // var moveTop = (firstTop-winScrollTop)*0.1 //speed;
//             var moveTop = ''; //speed;
//
//             // $(window).on('resize', function(){
//             //     var thisWin = $(this); //this = window
//             //     if (thisWin.width() >= 768) {
//             //         var moveTop = (firstTop-winScrollTop)*$parallaxEl.attr("data-parallax-md") //speed;
//             //     }
//             //     // else if (thisWin.width() >= 1200) {
//             //     //     var moveTop = (firstTop-winScrollTop)*$parallaxEl.attr("data-parallax-xl") //speed;
//             //     // }
//             //     else {
//             //         var moveTop = (firstTop-winScrollTop)*$parallaxEl.attr("data-parallax") //speed;
//             //     }
//             // }).resize();
//
//
//
//
//             // $(window).resize(function() {
//                 if (window.matchMedia('(max-width: 1200px)').matches) {
//                     var moveTop = (firstTop-winScrollTop)*$parallaxEl.attr("data-parallax") //speed;
//                 } else {
//                     var moveTop = (firstTop-winScrollTop)*$parallaxEl.attr("data-parallax-xl") //speed;
//                 }
//             // }).resize(); // inizializzo l'evento resize
//
//
//
//             $parallaxEl.css("transform","translateY("+-moveTop+"px)");
//         }
//
//     });
// }
//
// $(window).scroll(function(e){
//     winScrollTop = $(this).scrollTop();
//     $(window).resize(function() {
//         parallax();
//     }).resize(); // inizializzo l'evento resize
// });
